import { Loader2 } from "lucide-react";

const LoadingFallback = () => {
    return (
        <div className="flex h-screen w-full items-center justify-center bg-background">
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="h-10 w-10 animate-spin text-primary" />
                <p className="text-muted-foreground animate-pulse">Loading...</p>
            </div>
        </div>
    );
};

export default LoadingFallback;
